import { Link_Target } from "./../../../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { useBiNext } from "./../../../bi-context-provider/bi-context-provider.js";
import { LINK_MODAL_ID } from "./../../../link-modal/constants.js";
import {
  ATTRIBUTES_NEW_TAB,
  ATTRIBUTES_NOFOLLOW,
  ATTRIBUTES_NOREFERRER,
  ATTRIBUTES_SPONSORED
} from "./../../../link-modal/data-hooks/data-hooks.js";
const useAttributes = (link, onChange) => {
  const logBi = useBiNext({ pluginId: "link", modalId: LINK_MODAL_ID });
  return {
    onToggleNewTab: () => {
      onChange(link.rel, link.target !== Link_Target.BLANK ? Link_Target.BLANK : Link_Target.TOP);
      logBi({
        dataHook: ATTRIBUTES_NEW_TAB,
        value: link.target !== Link_Target.BLANK
      });
    },
    onToggleNofollow: () => {
      onChange(
        {
          ...link.rel,
          nofollow: !link.rel?.nofollow || void 0
        },
        link.target
      );
      logBi({ dataHook: ATTRIBUTES_NOFOLLOW, value: !link.rel?.nofollow });
    },
    onToggleNoreferrer: () => {
      onChange(
        {
          ...link.rel,
          noreferrer: !link.rel?.noreferrer || void 0
        },
        link.target
      );
      logBi({ dataHook: ATTRIBUTES_NOREFERRER, value: !link.rel?.noreferrer });
    },
    onToggleSponsored: () => {
      onChange(
        {
          ...link.rel,
          sponsored: !link.rel?.sponsored || void 0
        },
        link.target
      );
      logBi({ dataHook: ATTRIBUTES_SPONSORED, value: !link.rel?.sponsored });
    }
  };
};
export {
  useAttributes
};
//# sourceMappingURL=use-attributes.js.map
